import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Container, Card, Button, Spinner } from "react-bootstrap";
import NavbarComponent from "./DashboardNavbar.js";
import Swal from "sweetalert2";
import "./Dashboard.css";
 
const API_URL = process.env.REACT_APP_API_URL_EC2; // Load API URL from env
const token = process.env.REACT_APP_API_TOKEN; 

const ProductDetails = () => {
  const { productId, category } = useParams(); // Get parameters from URL
  const [product, setProduct] = useState(null); // State to store product data
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state
  const [id, setid] = useState();
  const [email, setemail] = useState();

  useEffect(() => {
    const storedUserdata = sessionStorage.getItem("user");
    if (storedUserdata) {
      const data = JSON.parse(storedUserdata);
      if (data.id) {
        setid(data.id);
        setemail(data.email);
      } else {
        console.error("ID is not available in stored user data.");
      }
    }
  }, []);

  useEffect(() => {
    const fetchProductDetails = async () => {
      try {
        const response = await axios.post(`${API_URL}/api/getSpecificImage`, {
          id: productId,
          category: category,
        });

        console.log(response);
        if (response.data && response.data.data) {
          setProduct(response.data.data[0]);
        } else {
          setError("Product not found.");
        }
      } catch (error) {
        setError("Failed to fetch product details.");
      } finally {
        setLoading(false);
      }
    };

    fetchProductDetails();
  }, [productId, category]);

  const handleNotify = async () => {
    try {
      // Get the token from your environment variable
      
      
      // Set headers with the Bearer token
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      console.log(headers)
      // Send the POST request with headers and product data
      const response = await axios.post(
        `${API_URL}/api/sendemail`,
        {
          userId: 1,
          subject: "Product Notification",
          message : `Product Name: ${product.title}, Price: $${product.price}, Link: ${product.slink}`,
          email : email

        },
        { headers } // Include headers in the request
      );
  
      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "success",
          text: "Notification Send",
          confirmButtonText: "OK",
        });
      }
      // Handle the response as needed (e.g., show a success message to the user)
    } catch (error) {
      console.error("Error sending email:", error);
      // Handle error accordingly (e.g., show an error message to the user)
    }
  };

  if (loading) {
    return (
      <Container className="py-4 text-center">
        <Spinner animation="border" variant="primary" />
        <p>Loading product details...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="py-4 text-center">
        <p className="text-danger">{error}</p>
      </Container>
    );
  }

  return (
    <div className="main-content">
      <NavbarComponent />
      <Container className="py-4">
        <Card className="shadow-lg text-center">
          {product ? (
            <>
              <Card.Img
                variant="top"
                src={product.image}
                alt={product.title}
                style={{
                  width: "100%",
                  maxHeight: "400px",
                  objectFit: "contain",
                  margin: "0 auto",
                }}
              />
              <Card.Body>
                <Card.Title>{product.title}</Card.Title>
                <Card.Text className="text-muted">
                  Category: {product.category}
                </Card.Text>
                <Card.Text className="fw-bold">Price: ${product.price}</Card.Text>
                <Card.Text className="fw-bold">
                  <a href={product.slink} target="_blank" rel="noopener noreferrer">
                    Click Here
                  </a>
                </Card.Text>
                <Button variant="success" onClick={handleNotify}>
                  Notify
                </Button>
              </Card.Body>
            </>
          ) : (
            <p>Product details are not available.</p>
          )}
        </Card>
      </Container>
    </div>
  );
};

export default ProductDetails;
